
webpack.register(
    'modules/qualifying-sectional-leaderboard/qualifying-sectional-leaderboard',
    function() {
        return import('modules/qualifying-sectional-leaderboard/qualifying-sectional-leaderboard');
    },
    true
);